import { Col, Form, Row } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../common/integrations'
import { IntegrationSettings } from '../../schema'
import { useIntegrations } from '../../../../useIntegrations'

type ExportActionField = 'enableContactCreate' | 'enableContactUpdate'

interface ExportActionGroup {
  field: ExportActionField
  label: string
  allowLabel: string
  denyLabel: string
  value: boolean
  supported: boolean
}

export interface ExportActionsSettingsProps {
  serviceId: IntegrationServiceId
}

export const ExportActionsSettings: React.FC<ExportActionsSettingsProps> = ({ serviceId }) => {
  const { watch, setValue } = useFormContext<IntegrationSettings>()
  const { supportsContactCreate, supportsContactUpdate } = useIntegrations()
  const integrationDisplayName = getIntegrationDisplayName(serviceId)
  const [enableContactCreate, enableContactUpdate] = watch(['enableContactCreate', 'enableContactUpdate'])

  const handleChange = (field: ExportActionField, checked: boolean) => {
    setValue(field, checked, { shouldDirty: true, shouldValidate: true })
  }

  const groups: ExportActionGroup[] = [
    {
      field: 'enableContactCreate',
      label: 'Contact Create',
      allowLabel: `Allow users to create new contacts in ${integrationDisplayName}`,
      denyLabel: `Do not allow users to create new contacts in ${integrationDisplayName}`,
      value: enableContactCreate ?? true,
      supported: supportsContactCreate(serviceId),
    },
    {
      field: 'enableContactUpdate',
      label: 'Contact Update',
      allowLabel: `Allow users to update existing contacts in ${integrationDisplayName}`,
      denyLabel: `Do not allow users to update existing contacts in ${integrationDisplayName}`,
      value: enableContactUpdate ?? true,
      supported: supportsContactUpdate(serviceId),
    },
  ]

  return (
    <>
      {groups
        .filter(({ supported }) => supported)
        .map(({ field, label, allowLabel, denyLabel, value }) => (
          <Row key={field} className='mb-4'>
            <Col>
              <div className='paragraph-medium bold mb-2'>{label}</div>
              <div className='d-flex flex-column gap-1'>
                <Form.Check type='radio' id={`${field}-allow`} name={field} label={allowLabel} checked={value} onChange={() => handleChange(field, true)} />
                <Form.Check type='radio' id={`${field}-deny`} name={field} label={denyLabel} checked={!value} onChange={() => handleChange(field, false)} />
              </div>
            </Col>
          </Row>
        ))}
    </>
  )
}
